import Vue from 'vue'
import Vuex from 'vuex'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  id: payload.id
})
var crud = new Crud('TransferDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  transferDetails: []
}

const mutations = {
  ...crud.mutations,
  SET_RECORDS (state, payload) {
    state.transferDetails = payload.data.details
  }
}

const actions = {
  ...crud.actions,
  async loadDetails ({ commit }, payload) {
    try {
      const response = await axios.get(`transfers/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  }
}

const getters = {
  ...crud.getters,
  transferDetails: state => state.transferDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
